export const SCORE_RULES = {
  perKill: 10,
  perBossKill: 200,
  perCoinEarned: 0.5,
  perRevive: 60,
  perDown: -30,
  perDeath: -100,
  accuracyBonus: 300,
  shotsForFullAccuracyBonus: 100,
} as const;
